module.exports = __webpack_public_path__ + "static/book-photo-cover-f43f9dd934ffdcfb1a6e45df575fa3a8.jpg";